import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { DragDropDrawer, Z3kDragDropContainer, } from 'z3k-settings/components/utils/drag-drop-drawer';
import { RouteNaming, Z3kSecondRoutes } from 'z3k-settings/routes/type';
export function MQTTTopicsList() {
    const childrenItem = (selected_item_id) => {
        return (_jsx(_Fragment, { children: _jsx(DragDropDrawer, { z3k_name: "mqtt_topics", name: RouteNaming[Z3kSecondRoutes.mqtt_topics], help_id: "mqtt_topics", item_url: Z3kSecondRoutes.mqtt_topics, enableDnd: true, selected_item_id: selected_item_id }) }));
    };
    const findId = (item_key, item_id, findInConfig) => {
        return (!item_id || !findInConfig) && item_key != Z3kSecondRoutes.mqtt_address;
    };
    const customButtons = [Z3kSecondRoutes.mqtt_address];
    return (_jsx(_Fragment, { children: _jsx(Z3kDragDropContainer, { childrenItem: childrenItem, findId: findId, customButtons: customButtons }) }));
}
MQTTTopicsList.isWarning = MQTTTopicsList.isError;
MQTTTopicsList.isError = () => {
    return false;
};
MQTTTopicsList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => parseInt(config.device.firmware) >= 420 &&
    config.mqtt_address != null &&
    is_service_view &&
    !is_climatic;
